import { useRef, useState, useEffect } from "react"
import { Button } from "../button/button"
import { FileType } from "../file-tile/types"
import { fileHelpers } from "../../../files"

type Props = {
    id: string
    fileTypes: FileType[]
    defaultValue?: File
    disabled?: boolean
    onChange: (value?: File) => void
    onRemove?: () => void
}

export const UploadButton = (props: Props) => {
    const { id, fileTypes, defaultValue, disabled, onChange, onRemove } = props

    const inputRef = useRef<HTMLInputElement | null>(null)
    const [uploadRef, setUploadRef] = useState<HTMLLabelElement | null>()

    const { toAccept } = fileHelpers

    useEffect(() => {
        if (defaultValue && inputRef.current) {
            const dataTransfer = new DataTransfer()
            dataTransfer.items.add(defaultValue)
            inputRef.current.files = dataTransfer.files
        }
    }, [])

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const files = e.target.files
        if (files) {
            const file = files[0]
            onChange(file)
        }
    }

    const handleLabelClick = (e: React.MouseEvent<HTMLLabelElement>) => {
        disabled && e.preventDefault()
    }

    const handleClickUpload = () => {
        !disabled && uploadRef?.click()
    }

    const clearInput = () => {
        if (inputRef.current) {
            inputRef.current.value = ''
            onRemove && onRemove()
        }
    }

    return (<>
        <input
            ref={inputRef}
            type="file"
            id={id}
            accept={toAccept(fileTypes)}
            hidden
            onChange={handleFileChange}
        />
        <label
            htmlFor={id}
            ref={ref => setUploadRef(ref)}
            onClick={handleLabelClick}
        >
            <Button
                icon='upload'
                tooltip="Seleccionar Archivo"
                disabled={disabled}
                rightMargin
                onClick={handleClickUpload}
            />
        </label>
        {onRemove && (
            <Button
                icon='trash-fill'
                kind='secondary'
                tooltip='Eliminar'
                disabled={disabled || !inputRef.current?.value}
                rightMargin
                onClick={clearInput}
            />
        )}
    </>)
}
